import type { ReactNode } from 'react';
import React, { createContext } from 'react';
import type { Container } from 'inversify';

interface InversifyContextValue {
  container: Container | null;
}

interface InversifyProviderProps {
  container: Container;
  children: ReactNode;
}

export const InversifyContext = createContext<InversifyContextValue>({
  container: null,
});

export const InversifyProvider = ({
  container,
  children,
}: InversifyProviderProps) => {
  return (
    <InversifyContext.Provider value={{ container }}>
      {children}
    </InversifyContext.Provider>
  );
};
